import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { Element } from '../../../../../common/html/element'
import { SelectCustom } from '../../../../../common/selectCustom'

export const SelectCell = ({ title, year, data, chooseItem }) => {
  const [activeItem, setActiveItem] = useState(title)
  const onChangeSelect = (e) => {
    chooseItem(e, year)
  }

  useEffect(() => {
    setActiveItem(title)
  }, [title])

  return (
    <Element
      elementName="th"
      style={{
        backgroundColor: '#E5E5E8',
        border: 'none',
        borderBottomWidth: 1,
        borderBottomStyle: 'solid',
        borderBottomColor: '#ffffff',
        padding: '0 12px',
      }}
    >
      <SelectCustom
        activeItem={activeItem}
        data={data}
        chooseItem={(e) => onChangeSelect(e)}
        style={{
          border: 'none',
          backgroundColor: '#E5E5E8',
          fontSize: 12,
          fontWeight: 400,
          padding: '8px 0',
          justifyContent: 'flex-end',
        }}
        isI18n={true}
        iconNoPosition={true}
        scrollId="companyAnalysis"
      />
    </Element>
  )
}

SelectCell.prototype = {
  title: PropTypes.string.isRequired,
  year: PropTypes.number.isRequired,
  data: PropTypes.array.isRequired,
  chooseItem: PropTypes.func.isRequired,
}
